import axios from 'axios';
import { token, baseUrl } from '../../../services/Apis';

export const HORARIOS_CONST = 'horarios';
export const horariosApi = `${baseUrl}/${HORARIOS_CONST}`;

export const allHorariosService = async (params) => {
  const res = await axios.get(horariosApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveHorariosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${horariosApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(horariosApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const updatedCalendarHorariosService = async (id, data) => {
  const res = await axios.patch(`${horariosApi}/${id}/updated-calendar`, data, {
    headers: token({}),
  });
  return res;
};

export const oneHorariosService = async (id) => {
  const res = await axios.get(`${horariosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteHorariosService = async (id) => {
  const res = await axios.delete(`${horariosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const allDocentesHorariosService = async (params) => {
  const res = await axios.get(`${horariosApi}/docentes`, {
    headers: token({}),
    params,
  });
  return res;
};
